import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3856e448"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["onClick"]

import { nextTick, onUnmounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    images: null,
    index: null,
    alt: null
  },
  emits: ["update:index"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:index', index: number | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    images: string[]
    index: number | null
    alt: string
}




const overlay = ref<HTMLElement | null>(null)

function close() {
    emit('update:index', null)
}

function step(delta: number) {
    if (props.index === null) return
    const count = props.images.length
    emit('update:index', (props.index + delta + count) % count)
}

function onKeydown(event: KeyboardEvent) {
    if (event.key === 'Escape') close()
    else if (event.key === 'ArrowLeft') step(-1)
    else if (event.key === 'ArrowRight') step(1)
}

// The page behind would otherwise scroll under the overlay.
watch(() => props.index, async (index, previous) => {
    document.body.style.overflow = index === null ? '' : 'hidden'
    if (index !== null && previous === null) {
        await nextTick()
        overlay.value?.focus()
    }
})

onUnmounted(() => {
    document.body.style.overflow = ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.index !== null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "overlay",
          ref: overlay,
          class: "lightbox",
          role: "dialog",
          "aria-modal": "true",
          "aria-label": __props.alt,
          tabindex: "-1",
          onClick: close,
          onKeydown: onKeydown
        }, [
          _createElementVNode("img", {
            class: "lightbox-image",
            src: __props.images[__props.index],
            alt: __props.alt
          }, null, 8, _hoisted_2),
          _createElementVNode("button", {
            type: "button",
            class: "lightbox-close",
            "aria-label": "Close",
            onClick: _withModifiers(close, ["stop"])
          }, "×", 8, _hoisted_3),
          (__props.images.length > 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "lightbox-nav lightbox-prev",
                  "aria-label": "Previous image",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (step(-1)), ["stop"]))
                }, "‹"),
                _createElementVNode("button", {
                  type: "button",
                  class: "lightbox-nav lightbox-next",
                  "aria-label": "Next image",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (step(1)), ["stop"]))
                }, "›")
              ], 64))
            : _createCommentVNode("", true)
        ], 40, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}
}

})